/**
 * ?��?工具
 */

import { DEBUG_CONFIG } from '@config/constants';

type LogLevel = 'log' | 'warn' | 'error';

class Logger {
  private enabled: boolean;
  private logLevel: LogLevel;

  constructor(enabled: boolean = DEBUG_CONFIG.enabled, logLevel: LogLevel = DEBUG_CONFIG.logLevel) {
    this.enabled = enabled;
    this.logLevel = logLevel;
  }

  /**
   * 设置?��?开??
   */
  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  /**
   * 设置?��?级别
   */
  setLogLevel(level: LogLevel): void {
    this.logLevel = level;
  }

  /**
   * ?�通日�?
   */
  log(...args: any[]): void {
    if (this.enabled && this.logLevel === 'log') {
      console.log(...args);
    }
  }

  /**
   * 信息日志（与log相同）
   */
  info(...args: any[]): void {
    if (this.enabled && this.logLevel === 'log') {
      console.log(...args);
    }
  }

  /**
   * 警�??��?
   */
  warn(...args: any[]): void {
    if (this.enabled && (this.logLevel === 'log' || this.logLevel === 'warn')) {
      console.warn(...args);
    }
  }

  /**
   * ?�误?��?（�?终�??��?
   */
  error(...args: any[]): void {
    console.error(...args);
  }

  /**
   * ?�能?��?
   */
  performance(label: string, fn: () => void): void {
    if (!this.enabled || !DEBUG_CONFIG.showPerformanceMetrics) {
      fn();
      return;
    }

    const start = performance.now();
    fn();
    const end = performance.now();
    console.log(`?��? ${label}: ${(end - start).toFixed(2)}ms`);
  }

  /**
   * 异步?�能?��?
   */
  async performanceAsync<T>(label: string, fn: () => Promise<T>): Promise<T> {
    if (!this.enabled || !DEBUG_CONFIG.showPerformanceMetrics) {
      return await fn();
    }

    const start = performance.now();
    const result = await fn();
    const end = performance.now();
    console.log(`?��? ${label}: ${(end - start).toFixed(2)}ms`);
    return result;
  }
}

// 导出?��?
export const logger = new Logger();

// 导出便捷?�数
export const log = (...args: any[]) => logger.log(...args);
export const warn = (...args: any[]) => logger.warn(...args);
export const error = (...args: any[]) => logger.error(...args);


